import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import { Button, Card, CardContent, CardHeader } from '@material-ui/core';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import useStyles from './dashboardstyles';
import DashboardTable from './dashboardtable';
import './dashboardstyles.css';
import { CommonConfig } from '../../../config/common-config';
import TabList from '../../../components/checklistTab/tabList';

const DetailAnalysis = () => {
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const user_token = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${user_token}`;
    const history = useHistory();
    const [savedJson, setSavedJson] = useState([]);
    const [AnalaysisRows, setAnalysisRows] = React.useState([]);
    const [AssigedUsers, setassigedUsers] = React.useState([]);
    const [reRender, setreRender] = React.useState();
    const tennantnameValue = tennantDetails && tennantDetails.tennantName;
    const [detailedRows, setDetailedRows] = React.useState({});
    const classes = useStyles();
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [savepop, setSavePop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [errorSave, setErrorSave] = useState('');
    const [isDisable, setIsDisable] = useState(true);
    let filesname = [];

    const headCells = [
        { id: 'questionText', label: 'What to analyze' },
        // { id: 'remarkByCoreteam', label: 'Remarks by Team' },
    ];

    const getResults = () => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: bearerToken,
            },
        };
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId/${imcNameSelected}/${serviceIdSelected}`, axiosConfig)
            .then((response) => {
                const data =
                    response.data &&
                    response.data.detailedAnalysis &&
                    response.data.detailedAnalysis.map((rowData) => {
                        return rowData;
                    });
                setSavedJson(response.data);
                setAnalysisRows(data);
                setDetailedRows(response.data);
                const dataAssignedUser =
                    response.data &&
                    response.data.assigedUsers &&
                    response.data.assigedUsers.map((rowData) => {
                        return rowData;
                    });
                setassigedUsers(dataAssignedUser)
            })
            .catch(() => {
            });
    };

    const addRemarks = (questionId, remark) => {
        const newArray = AnalaysisRows.map((row) => {
            if (row.questionId === questionId) {
                row.remarkByItecteam.unshift(remark);
            }
            return row;
        });
        setAnalysisRows(newArray);
    };

    const saveFile = (questionId, files) => {
        for (let i = 0; i < files.length; i++) {
            const data = new FormData();
            data.append('file', files[i]);
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantnameValue}/${serviceIdSelected}/myimage`, data, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    filesname.push(response.data);
                    const newArray = AnalaysisRows.map((row) => {
                        if (row.questionId === questionId) {
                            row.attachmentsByItecteam.push(filesname[0]);
                        }
                        return row;
                    });
                    setAnalysisRows(newArray);
                });
        }
    };
    const handleClose = () => {
        setShowLoader(false);
    };

    const handleDisable = (value) => {
        setIsDisable(value);
    };
    const savenSubmitData = (actionType) => {
        setSavedJson((prev) => ({ ...prev, detailedAnalysis: [...AnalaysisRows], assigedUsers: [...AssigedUsers], additionalQuestion: [] }));
        setSavedJson((updatedJson) => {
            const axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: bearerToken,
                },
            };
            const assignedData = JSON.stringify({
                serviceId: serviceIdSelected,
                detailedAnalysisJson: { ...updatedJson },
                remarks: 'Remarks',
            });

            if (actionType === 'save') {
                updatedJson.detailedAnalysis.filter((ele, i) => {
                    if (ele) {
                        if (ele.attachmentsByItecteam.length < 1 && ele.remarkByItecteam.length < 1) {
                            setErrorSave('Doc by ITeC-others and Remarks are required');
                        } else if (ele.attachmentsByItecteam.length < 1) {
                            setErrorSave('Doc by ITeC-others required');
                        } else if (ele.remarkByItecteam.length < 1) {
                            setErrorSave('Remarks requires');
                        } else {
                            setShowLoader(true);
                            axios
                                .put(
                                    `${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/itecothers-${actionType}/${imcNameSelected}`,
                                    JSON.parse(assignedData),
                                    axiosConfig
                                )
                                .then((response) => {
                                    if (response.status === 200) {
                                        if (actionType === 'save') {
                                            handleDisable(false);
                                            setErrorSave(false);
                                            setShowLoader(false);
                                            setSavePop(true);
                                            setreRender('update');
                                            setTimeout(() => {
                                                setSavePop(false);
                                            }, 1500);
                                        }
                                        handleClose();
                                    }
                                })
                                .catch((error) => {
                                    const errResult = error.response;
                                    if (errResult.data) {
                                        setTimeout(() => {
                                            setShowLoader(false);
                                            setErrorPop(true);
                                        }, 1500);
                                        setTimeout(() => {
                                            setErrorPop(false);
                                        }, 5000);
                                        setShowLoader(true);
                                        setErrorMsgGenerateRecceipt(errResult.data.message);
                                    }
                                });
                        }
                    }
                });
            } else {
                setShowLoader(true);
                axios
                    .put(
                        `${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/itecothers-${actionType}/${imcNameSelected}`,
                        JSON.parse(assignedData),
                        axiosConfig
                    )
                    .then((response) => {
                        if (response.status === 200) {
                            if (actionType === 'am-submit' || 'em-submit') {
                                setTimeout(() => {
                                    setShowLoader(false);
                                    setSuccessPop(true);
                                }, 1500);
                                setTimeout(() => {
                                    setSuccessPop(false);
                                    history.push({
                                        pathname: '/menu/openserviceall',
                                        state: { domainname: imcNameSelected }
                                    });
                                }, 3000);
                            }
                            handleClose();
                        }
                    })
                    .catch((error) => {
                        const errResult = error.response;
                        if (errResult.data) {
                            setTimeout(() => {
                                setShowLoader(false);
                                setErrorPop(true);
                            }, 1500);
                            setTimeout(() => {
                                setErrorPop(false);
                            }, 5000);
                            setShowLoader(true);
                            setErrorMsgGenerateRecceipt(errResult.data.message);
                        }
                    });
            }
        });
    };

    useEffect(() => {
        getResults();
    }, [imcNameSelected, serviceIdSelected, reRender]);

    const navigate = () => {
        history.push({
            pathname: '/menu/openserviceall',
            state: { domainname: imcNameSelected }
        });
    };

    return (
        <>
            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Submitted Detailed Analysis successfully"
                />
            ) : null}
            {savepop ? (
                <SuccessPopUp open={savepop} showSuccess={savepop} handleClose={handleClose} title="Details saved successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <div className={classes.root}>
                <TabList />
                <Card className="common-card">
                    <CardHeader title={'Detailed Analysis'} />
                    <CardContent>
                        <DashboardTable
                            headCells={headCells}
                            AnalaysisRows={AnalaysisRows}
                            pageName="dashboard"
                            action="document"
                            addRemarks={addRemarks}
                            saveFile={saveFile}
                        />
                    </CardContent>
                </Card>
                {errorSave ? (
                    <span className="itec-validationError" style={{ marginLeft: '4px' }}>
                        {errorSave}
                    </span>
                ) : null}
                <div className="detailed-actions">
                    {showLoader ? (
                        <LoaderPopUp
                            showLoader={showLoader}
                            handleClose={handleClose}
                            title="Please wait while we saving/submitting your data"
                        />
                    ) : null}
                    <ul>
                        <li>
                            <Button type="button" color="primary" variant="contained" size="large" onClick={navigate}>
                                Back
                            </Button>
                        </li>
                        <li>
                            <Button type="button" color="primary" variant="contained" size="large" onClick={() => savenSubmitData('save')}>
                                Save
                            </Button>
                        </li>
                        <li>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                size="large"
                                disabled={isDisable}
                                onClick={() => savenSubmitData('am-submit')}
                            >
                                Submit
                            </Button>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default DetailAnalysis;
